var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "noun-arrow-1787131-FFFFFF (1)",
    d: "M5.962 6a.545.545 0 01-.328-.136L.183.957A.548.548 0 11.916.143L6 4.72 11.085.142a.548.548 0 11.733.814L6.366 5.862A.545.545 0 015.962 6z",
    fill: "currentColor"
  })));
}

export default SvgAngleDown;